import { Box, Grid2, Stack, useTheme } from "@mui/material";
import { LeftName } from "./LeftName";
import { CenterPagination } from "./CenterPagination";
import { RightSave } from "./RightSave";
import { QuestionnaireUpdatePage } from "../../layouts/QuestionnaireUpdateFormWithPages";
import { Loading } from "src/components/utils/Loading";

type Props = {
    pages: QuestionnaireUpdatePage[] | undefined;
};
export const TopBarFullWidth = (props: Props) => {
    const theme = useTheme();

    const { pages } = props;
    if (pages === undefined) {
        return <Loading />;
    }
    return (
        <Stack
            sx={{
                zIndex: 1100,
                position: "sticky",
                top: "0px",
                minHeight: "96px",
                boxShadow: `0px 2px 8px 0px #2A2B270A`,

                backgroundColor: "#FFFFFF",
                padding: {
                    xs: theme.spacing(2, 1),
                    lg: theme.spacing(2, 3.5, 2, 3),
                },
                justifyContent: "center",
            }}
        >
            <Box display={{ xs: "block", lg: "none" }}>
                <Grid2 width={"100%"} alignItems={"center"} container columns={12} spacing={2}>
                    <Grid2
                        size={{ xs: 11, sm: 6 }}
                        justifyItems={{ xs: "center", md: "start" }}
                        sx={{
                            paddingLeft: "16px",
                        }}
                    >
                        <LeftName />
                    </Grid2>
                    <Grid2 size={{ xs: 1, sm: 6 }} justifyItems={{ xs: "center", md: "start" }}>
                        <RightSave />
                    </Grid2>
                    <Grid2 size={{ md: 12, sm: 12, xs: 12 }} justifyItems={"center"} alignItems={"end"}>
                        <CenterPagination pages={pages} />
                    </Grid2>
                </Grid2>
            </Box>
            <Box display={{ xs: "none", lg: "block" }}>
                <Grid2 width={"100%"} alignItems={"center"} container columns={12} spacing={2}>
                    <Grid2 size={{ lg: 3, md: 4 }}>
                        <LeftName />
                    </Grid2>
                    <Grid2 size={{ lg: 5, md: 4 }}>
                        <CenterPagination pages={pages} />
                    </Grid2>
                    <Grid2 size={{ lg: 4, md: 4 }} minWidth={"220px"} justifyItems={"end"} alignItems={"end"}>
                        <RightSave />
                    </Grid2>
                </Grid2>
            </Box>
        </Stack>
    );
};
